import React from 'react'

interface IImageProps {
  url: string
}

const Image: React.FC<IImageProps> = ({ url }) => {
  return (
    <img
      src={url}
      alt='Картинка'
      className='img-thumbnail'
      style={{ width: '200px' }}
    ></img>
  )
}
export default Image
